import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { useResponsiveTypography } from '../../../utility/responsiveTypography'
import { useAuthContext } from '../../../hooks/useAuthContext'
import FilePreviewField from '../../../pages/DataEntryPage/Fields/FilePreviewField'
import { fileServices } from '../../../services/fileServices'
import moment from 'moment'
import './Style.css'

const AdditionalNotes = ({ additionalNotes }) => {
  const { user } = useAuthContext()
  const { previewPageFont, previewText } = useResponsiveTypography()
  return (
    <div className="fieldset-legend">
      {additionalNotes?.length > 0 ? (
        <fieldset
          className="fieldsetbox"
          style={{
            borderRadius: '20px',
            marginBottom: '10px',
          }}
        >
          <legend
            style={{
              height: '32px',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              top: '-16px',
            }}
          >
            <Typography
              className="textprimaryblue fontWeight700"
              style={{ fontSize: previewPageFont }}
            >
              Additional Notes
            </Typography>
          </legend>
          <Box
            sx={{
              display: 'flex',
              gap: '150px',
              padding: '0px 5px',
              margin: '16px 4px',
            }}
          >
            <Table className="responsivetable">
              <TableHead>
                <TableCell
                  sx={{
                    fontSize: previewText,
                  }}
                >
                  Type
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: previewText,
                  }}
                >
                  Brief Description
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: previewText,
                  }}
                >
                  Content
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: previewText,
                  }}
                >
                  Activity
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: previewText,
                  }}
                >
                  Added by
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: previewText,
                  }}
                >
                  Added on
                </TableCell>
              </TableHead>
              <TableBody>
                {additionalNotes
                  ?.sort((a, b) => moment(a.modified_at) - moment(b.modified_at))
                  .map((data) => (
                    <TableRow key={data.id}>
                      <TableCell>{data.data_structure}</TableCell>
                      <TableCell
                        sx={{
                          fontSize: previewText,
                        }}
                      >
                        <Box sx={{ paddingBlock: 1 }}>{data.description}</Box>
                      </TableCell>

                      <TableCell
                        sx={{
                          fontSize: previewText,
                        }}
                      >
                        {data.data_structure === 'text' ? (
                          <Box sx={{ paddingBlock: 1 }}>{data.content}</Box>
                        ) : (
                          <Box sx={{ paddingBlock: 1 }}>
                            {' '}
                            <FilePreviewField
                              id={'filePreview'}
                              value={data.content}
                              download={() => fileServices.downloadFile(user, data.content)}
                              disabled={true}
                              size="small"
                            />
                          </Box>
                        )}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: previewText,
                        }}
                      >
                        {data.activity_template_name} (version {data.version})
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: previewText,
                        }}
                      >
                        {data.name} ({data.email} )
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: previewText,
                        }}
                      >
                        {moment(data.modified_at).format('DD MMM YYYY, HH:mm A')}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </Box>
        </fieldset>
      ) : null}
    </div>
  )
}

export default AdditionalNotes
